const AvatarCheckIcon = ({ style }) => {
  return (
    <svg
      height="22"
      width="22"
      fill="none"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <rect height="20" width="20" fill="#85C553" rx="10" x="1" y="1" />
      <rect height="20" width="20" rx="10" stroke="white" strokeWidth="2" x="1" y="1" />
      <path
        d="M15 8L9.5 13.5L7 11"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
      />
    </svg>
  );
};

export default AvatarCheckIcon;
